import { usageId } from "../../constants/usageid.js";
import { UserSchemaIds, UserTags } from "../../schemas/user.const.js";
export const dictionary = {
    schema: {
        // [UserSchemaIds_deprecated.USER]: {
        //   title: 'Human agent',
        //   description: 'A human agent that interacts with the system.',
        // },
        // [UserSchemaIds_deprecated.USER_LIST]: {
        //   title: 'List of human agents',
        //   description: 'A list of human agents.',
        // },
        // [UserSchemaIds_deprecated.USER_WITH_EMAIL]: {
        //   title: 'Human agent inc. email',
        //   description:
        //     'A human agent that interacts with the system including their email.',
        // },
        // [UserSchemaIds_deprecated.USER_WITH_EMAIL_LIST]: {
        //   title: 'List of human agents including their email',
        //   description: 'A list of human agents including their email.',
        // },
        // [UserSchemaIds_deprecated.USER_FILTER]: {
        //   title: 'Human agent filter',
        //   description: 'Collection of optional values where to filter on.',
        // },
        // [UserSchemaIds_deprecated.CREATE_USER]: {
        //   title: 'Human domain agent to create',
        //   description: 'Details of the to be created human domain agent.',
        // },
        // [UserSchemaIds_deprecated.CREATE_SYSTEM_ADMINISTRATOR]: {
        //   title: 'System administrator',
        //   description: 'Details of the system administrator.',
        // },
        // [UserSchemaIds_deprecated.CREATE_ACCOUNT_ADMINISTRATOR]: {
        //   title: 'Account administrator',
        //   description: 'Details of account administrator.',
        // },
        // [UserSchemaIds_deprecated.CREATE_MEMBER]: {
        //   title: 'Human member agent to create',
        //   description: 'Details of the to be created human member agent.',
        // },
        // [UserSchemaIds_deprecated.UPDATE_SYSTEM_USER]: {
        //   title: 'Human system agent properties to update',
        //   description:
        //     'Collection of optional properties to update on a human system agent.',
        // },
        // [UserSchemaIds_deprecated.UPDATE_DOMAIN_USER]: {
        //   title: 'User',
        //   description: 'A human agent that interacts with the system.',
        // },
        // [UserSchemaIds_deprecated.USER_PROFILE]: {
        //   title: 'User Profile',
        //   description:
        //     'The profile of a human agent that interacts with the system.',
        // },
        // [UserSchemaIds_deprecated.MEMBER_PROFILE]: {
        //   title: 'Member Profile',
        //   description:
        //     'The profile of a human agent that mainly registers observations to the system.',
        // },
        [usageId(UserSchemaIds.USER_WITH_EMAIL, UserTags.TEAM)]: {
            title: 'Team',
            description: 'System or Reseller administrator.',
        },
        [usageId(UserSchemaIds.USER_WITH_EMAIL, UserTags.DOMAIN)]: {
            title: 'User',
            description: 'Atlas user.',
        },
        [usageId(UserSchemaIds.USER_WITH_EMAIL, UserTags.ACCOUNT_AS_TEAM)]: {
            title: 'Reseller\'s Atlas administrator',
            description: 'Administrator, working for a reseller, with full privileges on an atlas.',
        },
        [usageId(UserSchemaIds.USER_WITH_EMAIL, UserTags.ACCOUNT_AS_ACCOUNT)]: {
            title: 'Atlas administrator',
            description: 'Administrator with full privileges on an atlas.',
        },
        [usageId(UserSchemaIds.CREATE_MEMBER, UserTags.DEFAULT)]: {
            title: 'Account',
            description: 'An account enables you to manage your observations',
            abbr: 'Register',
            cti: 'Register for access to more restricted atlases.',
        },
        [usageId(UserSchemaIds.USER_WITH_EMAIL, UserTags.MEMBER_AS_TEAM)]: {
            title: 'Member',
            description: 'A member participates in observations.',
        },
        [usageId(UserSchemaIds.USER_WITH_EMAIL, UserTags.MEMBER_AS_ACCOUNT)]: {
            title: 'Member',
            description: 'A member participates in observations.',
        },
        [usageId(UserSchemaIds.USER_PROFILE, UserTags.DEFAULT)]: {
            title: 'Your Profile',
            description: 'Your personal settings.',
            abbr: 'Profile',
            cti: 'Please update your settings here.',
        },
        [usageId(UserSchemaIds.MEMBER_PROFILE, UserTags.DEFAULT)]: {
            title: 'Your Profile',
            description: 'Your personal settings.',
            abbr: 'Profile',
            cti: 'Please update your settings here.',
        },
    }
};
